module.exports = global["$"] = require("-!./jquery-2.2.4.min.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/expose-loader?$!./mortgage/v7/jquery/jquery-2.2.4.min.js
// module id = 309
// module chunks = 49 50 53 54 55